import SubmitResearch from "@src/templates/singles/submit-research";

export default SubmitResearch;
